export default __webpack_public_path__ + "static/media/014-landslide.95fe613d.svg";